import request from '@/utils/request'
import { btcguid } from '@/utils/validate'
import { getToken } from '@/utils/auth'

export function getStatisticalData(params) {
  return request({
    url: '/GetStatisticalData',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 501,
      MessageID: btcguid(),
      Data: {}
    }
  })
}

export function getCrmAndTodoDate(userid) {
  return request({
    url: '/GetCrmAndTodoDate',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 502,
      MessageID: btcguid(),
      Data: {
        UserID: userid
      }
    }
  })
}

export function importCustomsData(params) {
  const formData = new FormData()
  formData.append('MessageType', 503)
  formData.append('MessageID', btcguid())
  formData.append('Files', params.Files)
  return request({
    url: '/ImportCustomsData',
    method: 'post',
    headers: {
      'Authorization': getToken(),
      'Content-Type': 'multipart/form-data'
    },
    data: formData
  })
}

export function queryCustomsData(params) {
  return request({
    url: '/QueryCustomsData',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 504,
      MessageID: btcguid(),
      Data: {
        PageNum: params.PageNum,
        PageSize: params.PageSize
      }
    }
  })
}

export function importSmartPushData(params) {
  const formData = new FormData()
  formData.append('MessageType', 505)
  formData.append('MessageID', btcguid())
  formData.append('Files', params.Files)
  return request({
    url: '/ImportSmartPushData',
    method: 'post',
    headers: {
      'Authorization': getToken(),
      'Content-Type': 'multipart/form-data'
    },
    data: formData
  })
}

export function getSmartPushData(params) {
  return request({
    url: '/GetSmartPushData',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 506,
      MessageID: btcguid(),
      Data: {
        PageNum: params.PageNum,
        PageSize: params.PageSize
      }
    }
  })
}

// ---------------- 必孚数据相关接口-------------------

export function importCustomData(params) {
  const formData = new FormData()
  formData.append('MessageType', 507)
  formData.append('MessageID', btcguid())
  formData.append('Files', params.Files)
  return request({
    url: '/ImportCustomData',
    method: 'post',
    headers: {
      'Authorization': getToken(),
      'Content-Type': 'multipart/form-data'
    },
    data: formData
  })
}

export function importApprovePlantData(params) {
  const formData = new FormData()
  formData.append('MessageType', 508)
  formData.append('MessageID', btcguid())
  formData.append('Files', params.Files)
  return request({
    url: '/ImportApprovePlantData',
    method: 'post',
    headers: {
      'Authorization': getToken(),
      'Content-Type': 'multipart/form-data'
    },
    data: formData
  })
}

export function importExportToChinaData(params) {
  const formData = new FormData()
  formData.append('MessageType', 509)
  formData.append('MessageID', btcguid())
  formData.append('Files', params.Files)
  return request({
    url: '/ImportExportToChinaData',
    method: 'post',
    headers: {
      'Authorization': getToken(),
      'Content-Type': 'multipart/form-data'
    },
    data: formData
  })
}

export function importCountrySlaughterData(params) {
  const formData = new FormData()
  formData.append('MessageType', 510)
  formData.append('MessageID', btcguid())
  formData.append('Files', params.Files)
  return request({
    url: '/ImportCountrySlaughterData',
    method: 'post',
    headers: {
      'Authorization': getToken(),
      'Content-Type': 'multipart/form-data'
    },
    data: formData
  })
}

export function importPlantSlaughterData(params) {
  const formData = new FormData()
  formData.append('MessageType', 511)
  formData.append('MessageID', btcguid())
  formData.append('Files', params.Files)
  return request({
    url: '/ImportPlantSlaughterData',
    method: 'post',
    headers: {
      'Authorization': getToken(),
      'Content-Type': 'multipart/form-data'
    },
    data: formData
  })
}

export function importGreyChannelData(params) {
  const formData = new FormData()
  formData.append('MessageType', 512)
  formData.append('MessageID', btcguid())
  formData.append('Files', params.Files)
  return request({
    url: '/ImportGreyChannelData',
    method: 'post',
    headers: {
      'Authorization': getToken(),
      'Content-Type': 'multipart/form-data'
    },
    data: formData
  })
}

export function getCustomData(params) {
  return request({
    url: '/GetCustomData',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 513,
      MessageID: btcguid(),
      Data: {
        PageNum: params.PageNum,
        PageSize: params.PageSize
      }
    }
  })
}

export function getApprovePlantData(params) {
  return request({
    url: '/GetApprovePlantData',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 514,
      MessageID: btcguid(),
      Data: {
        Keyword: params.Keyword,
        PageNum: params.PageNum,
        PageSize: params.PageSize
      }
    }
  })
}

export function updateApprovePlantState(params) {
  return request({
    url: '/UpdateApprovePlantState',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 515,
      MessageID: btcguid(),
      Data: {
        PlantState: params.PlantState,
        ApprovePlantID: params.ApprovePlantID
      }
    }
  })
}

export function getExportToChinaData(params) {
  return request({
    url: '/GetExportToChinaData',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 515,
      MessageID: btcguid(),
      Data: {
        PageNum: params.PageNum,
        PageSize: params.PageSize
      }
    }
  })
}

export function getCountrySlaughterData(params) {
  return request({
    url: '/GetCountrySlaughterData',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 516,
      MessageID: btcguid(),
      Data: {
        PageNum: params.PageNum,
        PageSize: params.PageSize
      }
    }
  })
}

export function getPlantSlaughterData(params) {
  return request({
    url: '/GetPlantSlaughterData',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 517,
      MessageID: btcguid(),
      Data: {
        PageNum: params.PageNum,
        PageSize: params.PageSize
      }
    }
  })
}

export function getGreyChannelData(params) {
  return request({
    url: '/GetGreyChannelData',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 518,
      MessageID: btcguid(),
      Data: {
        PageNum: params.PageNum,
        PageSize: params.PageSize
      }
    }
  })
}

// ------------------------------------- 破壳数据 -----------------------------------------------

export function importPorkData(params) {
  const formData = new FormData()
  formData.append('MessageType', 519)
  formData.append('MessageID', btcguid())
  formData.append('Files', params.Files)
  return request({
    url: '/ImportPorkData',
    method: 'post',
    headers: {
      'Authorization': getToken(),
      'Content-Type': 'multipart/form-data'
    },
    data: formData
  })
}

export function getPorkData(params) {
  return request({
    url: '/GetPorkData',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 520,
      MessageID: btcguid(),
      Data: {
        PageNum: params.PageNum,
        PageSize: params.PageSize
      }
    }
  })
}

export function importPorkCustomsData(params) {
  const formData = new FormData()
  formData.append('MessageType', 521)
  formData.append('MessageID', btcguid())
  formData.append('Files', params.Files)
  return request({
    url: '/ImportPorkCustomsData',
    method: 'post',
    headers: {
      'Authorization': getToken(),
      'Content-Type': 'multipart/form-data'
    },
    data: formData
  })
}

export function getPorkCustomsData(params) {
  return request({
    url: '/GetPorkCustomsData',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 522,
      MessageID: btcguid(),
      Data: {
        PageNum: params.PageNum,
        PageSize: params.PageSize
      }
    }
  })
}

export function importPorkEstData(params) {
  const formData = new FormData()
  formData.append('MessageType', 523)
  formData.append('MessageID', btcguid())
  formData.append('Files', params.Files)
  return request({
    url: '/ImportPorkEstData',
    method: 'post',
    headers: {
      'Authorization': getToken(),
      'Content-Type': 'multipart/form-data'
    },
    data: formData
  })
}

export function getPorkEstData(params) {
  return request({
    url: '/GetPorkEstData',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 524,
      MessageID: btcguid(),
      Data: {
        PageNum: params.PageNum,
        PageSize: params.PageSize,
        Origin: params.Origin,
        PlantNo: params.PlantNo
      }
    }
  })
}

export function getPlantCategoryCount(params) {
  return request({
    url: '/GetPlantCategoryCount',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 525,
      MessageID: btcguid(),
      Data: {
        PageNum: params.PageNum,
        PageSize: params.PageSize
      }
    }
  })
}

export function getPlantConditionCount(params) {
  return request({
    url: '/GetPlantConditionCount',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 526,
      MessageID: btcguid(),
      Data: {
        PageNum: params.PageNum,
        PageSize: params.PageSize
      }
    }
  })
}

export function uploadAdvertisement2688(params) {
  const formData = new FormData()
  formData.append('MessageType', 527)
  formData.append('MessageID', btcguid())
  formData.append('Files', params.Files)
  return request({
    url: '/UploadAdvertisement2688',
    method: 'post',
    headers: {
      'Authorization': getToken(),
      'Content-Type': 'multipart/form-data'
    },
    data: formData
  })
}

export function uploadAdvertisement2208(params) {
  const formData = new FormData()
  formData.append('MessageType', 527)
  formData.append('MessageID', btcguid())
  formData.append('Files', params.Files)
  return request({
    url: '/UploadAdvertisement2208',
    method: 'post',
    headers: {
      'Authorization': getToken(),
      'Content-Type': 'multipart/form-data'
    },
    data: formData
  })
}

export function getPlantUpdateState(params) {
  return request({
    url: '/GetPlantUpdateState',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 528,
      MessageID: btcguid(),
      Data: {
        PageNum: params.PageNum,
        PageSize: params.PageSize,
        Keyword: params.KeyWord
      }
    }
  })
}

export function addPlantUpdateState(params) {
  return request({
    url: '/AddPlantUpdateState',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 529,
      MessageID: btcguid(),
      Data: {
        Origin: params.Origin,
        OriginEn: params.OriginEn,
        PlantNo: params.PlantNo,
        UpdateState: params.UpdateState,
        EnNewsID: params.EnNewsID,
        NewsID: params.NewsID,
        IsNew: params.IsNew,
        Order: params.Order
      }
    }
  })
}

export function importBtcPriceData(params) {
  const formData = new FormData()
  formData.append('MessageType', 530)
  formData.append('MessageID', btcguid())
  formData.append('Files', params.Files)
  return request({
    url: '/ImportBtcPriceData',
    method: 'post',
    headers: {
      'Authorization': getToken(),
      'Content-Type': 'multipart/form-data'
    },
    data: formData
  })
}

export function importLiveCattle(params) {
  const formData = new FormData()
  formData.append('MessageType', 531)
  formData.append('MessageID', btcguid())
  formData.append('Files', params.Files)
  return request({
    url: '/ImportLiveCattle',
    method: 'post',
    headers: {
      'Authorization': getToken(),
      'Content-Type': 'multipart/form-data'
    },
    data: formData
  })
}

export function updatePorkDataEst(params) {
  return request({
    url: '/UpdatePorkDataEst',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 532,
      MessageID: btcguid(),
      Data: {
        PorkDataEstID: params.PorkDataEstID,
        PlantNo: params.PlantNo,
        PlantNoEn: params.PlantNoEn
      }
    }
  })
}

export function updatePorkEstDataState(params) {
  return request({
    url: '/UpdatePorkEstDataState',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 533,
      MessageID: btcguid(),
      Data: {
        PlantState: params.PlantState,
        PorkDataEstID: params.PorkDataEstID
      }
    }
  })
}

export function importPorkAppData(params) {
  const formData = new FormData()
  formData.append('MessageType', 534)
  formData.append('MessageID', btcguid())
  formData.append('Files', params.Files)
  formData.append('Path', params.Path)
  return request({
    url: '/ImportPorkAppData',
    method: 'post',
    headers: {
      'Authorization': getToken(),
      'Content-Type': 'multipart/form-data'
    },
    data: formData
  })
}

export function getPorkNewData(params) {
  return request({
    url: '/GetPorkNewData',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 535,
      MessageID: btcguid(),
      Data: {
        PageNum: params.PageNum,
        PageSize: params.PageSize
      }
    }
  })
}

export function getPorkNewCustomsData(params) {
  return request({
    url: '/GetPorkNewCustomsData',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 536,
      MessageID: btcguid(),
      Data: {
        PageNum: params.PageNum,
        PageSize: params.PageSize
      }
    }
  })
}

export function GetAdvertiesment(params) {
  return request({
    url: '/GetAdvertiesment',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 537,
      MessageID: btcguid(),
      Data: {
        AdvertisementID: params
      }
    }
  })
}



// WEBPACK FOOTER //
// ./src/api/data.js